/**
 * Per-domain icons for the end-to-end processes in the taxonomy: the fifteen from
 * Microsoft's Business Process Catalog plus any defined here. Imported by the process
 * browser and the process map so the icon language stays consistent across the app.
 */
import {
  Boxes,
  Briefcase,
  CalendarCheck,
  DraftingCompass,
  Factory,
  FileSpreadsheet,
  LifeBuoy,
  Lightbulb,
  Receipt,
  Settings2,
  Target,
  TrendingUp,
  Truck,
  Users,
  Wallet,
  Wrench,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  "acquire-to-dispose": Boxes,
  "administer-to-operate": Settings2,
  "case-to-resolution": LifeBuoy,
  "concept-to-market": Lightbulb,
  "design-to-retire": DraftingCompass,
  "forecast-to-plan": TrendingUp,
  "hire-to-retire": Users,
  "inventory-to-deliver": Truck,
  "order-to-cash": Receipt,
  "plan-to-produce": Factory,
  "project-to-profit": Briefcase,
  "prospect-to-quote": Target,
  "record-to-report": FileSpreadsheet,
  "service-to-deliver": Wrench,
  "source-to-pay": Wallet,
  "work-management": CalendarCheck,
};

/** Returns the icon component for the end-to-end root of any taxonomy node id. */
export function iconForDomain(nodeId: string): LucideIcon {
  const root = nodeId.split("/")[0] ?? nodeId;
  return ICONS[root] ?? Boxes;
}
